export const ru = {
    forbidden_title: 'Доступ запрещен',
    not_found_title: 'Страница не найдена',
    forbidden_description: 'Кажется, у вас нет доступа к этой странице. Попробуйте обновить сраницу или вернитесь позже',
    not_found_description: 'Возможно, вы попытались загрузить несуществующую или удаленную страницу. Вернитесь назад или свяжитесь с поддержкой',
};
